import { APP_ROUTES } from "@/core/constants";
import type { AppRouteDefinition } from "@/core/router";

import { DashboardPage } from "../views";

export const dashboardRoutes: readonly AppRouteDefinition[] = [
  {
    route: APP_ROUTES.superAdmin.dashboard,
    element: <DashboardPage />,
  },
] as const;
